import { Badge } from '@vrplatform/components';
import type { party_enum } from '@vrplatform/graphql';

type Props = {
  party: party_enum;
};

export const TagParty = ({ party }: Props) => {
  if (party === 'owners') {
    return (
      <Badge
        appearance="tag"
        leftIcon={'UsersIcon'}
        leftIconColor={(theme) => theme.colors[theme.primaryColor][6]}
      >
        Owner
      </Badge>
    );
  }

  if (party === 'manager') {
    return (
      <Badge
        appearance="tag"
        leftIcon={'BriefcaseIcon'}
        leftIconColor={(theme) => theme.colors.violet[7]}
      >
        Manager
      </Badge>
    );
  }

  return null;
};
